import { makeUrl } from "@uplift-ltd/strings";
import React, { ReactElement } from "react";
import Button, { ButtonLink } from "components/common/Button";
import { CombinedEvent } from "components/events/queries";
import { COURSE_URL } from "constants/urls";
import { EventState, getEnrollmentDetailsForEvent } from "helpers/courseDetails";
import styles from "./Event.module.css";

type EventEndedProps = {
  event: CombinedEvent;
};

const SidebarEnded: React.FC<EventEndedProps> = ({ event }) => {
  const { course } = event;

  const courseUrl = course?.slug
    ? makeUrl(COURSE_URL, {
        slug: course.slug,
        page: "",
      })
    : null;

  if (!course || !courseUrl) {
    return null;
  }

  const details = getEnrollmentDetailsForEvent(course, event);
  const buttonText = details?.buttonText;
  const eventState = details?.eventState;
  const messageText = details?.messageText;

  let actionButton: ReactElement | null = null;

  if (eventState === EventState.AWAITING_READINESS) {
    actionButton = (
      <>
        <Button theme="primary" disabled className={styles.marginTop}>
          {buttonText}
        </Button>
        <div className={styles.marginTop}>{messageText}</div>
      </>
    );
  } else if (event.isRegistered || course.displayInCatalog) {
    actionButton = (
      <ButtonLink theme="primary" href={courseUrl} className={styles.marginTop}>
        View Course
      </ButtonLink>
    );
  }

  return (
    <>
      <div className={styles.sidebarRegistered}>This event has ended</div>
      {actionButton}
    </>
  );
};

export default SidebarEnded;
